module.exports = __webpack_public_path__ + "img/icon-baoming.16056c87.png";